__turbopack_context__.v({
  "richText": "-f988G_richText",
});
